import { api } from '../index';

const BASE_PATH = '/api/internal/planning/monthly_tracking';

export type MonthlyTrackingRow = {
  patientId: number;
  patientFullName: string | null;
  career: string;
  humanCareer: string;
  cap: number;
  planned: number;
  actual: number;
  percentUsed: number;
  driftDays: string[];
};

export type MonthlyTrackingResponse = {
  monthlyTrackingRows: MonthlyTrackingRow[];
  year: number;
  month: number;
};

function presentIds(ids?: number[]): number[] | undefined {
  return ids && ids.length > 0 ? ids : undefined;
}

export const monthlyTrackingApi = {
  index(
    year: number,
    month: number,
    groupIds?: number[],
    categoryFilter?: { serviceCategoryIdIn?: number[]; uncategorized?: boolean },
  ): Promise<MonthlyTrackingResponse> {
    const params: Record<string, unknown> = {
      year,
      month,
      'group_id_in[]': presentIds(groupIds),
      'service_category_id_in[]': presentIds(categoryFilter?.serviceCategoryIdIn),
      uncategorized: categoryFilter?.uncategorized || undefined,
    };

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then(response => response.data);
  },
};
